export const containerClass = 'z-[1] relative overflow-visible';

export const gridWrapperClass = (columnCount: number) => {
    if (columnCount === 1) {
        return { className: 'relative grid w-full gap-y-sm grid-cols-1 gap-x-0' };
    }
    return {
        className: 'w-full grid relative gap-m',
        style: { gridTemplateColumns: `repeat(${columnCount},1fr)` },
    };
};
